export class ListSparkJobsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "sparkEngineId",
            "baseName": "sparkEngineId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "sparkEngineName",
            "baseName": "sparkEngineName",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkJobStatusFilters",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "DateRangeFilter",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkJobsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
